import Table from "components/DataTable/Table";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { socket } from "../../socket";

export default function WebHook() {
  /*   ALL STATES
   ********************************************* */

  const [webHookData, setWebHookData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isConnected, setIsConnected] = useState(null);
  const [selectedWebhook, setSelectedWebhook] = useState(null);

  /*   All Functions
   ********************************************* */
  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      console.log("back-end connected");
    }

    function onDisconnect() {
      setIsConnected(false);
      console.log("back-end disconnected");
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    // Listen for 'newSms' event from the server

    // Listen for 'smsRead' event from the server
    // socket.on("smsRead", getUnreadSmsCount);

    // Listen for new Mockup msg
    socket.on("web-hook", (data) => {
      console.log("web-hook received", data);
      setWebHookData((prevData) => [...prevData, data]);
    });

    return () => {
      // if (
      //   user?.permissions?.includes('sms_view') ||
      //   user?.permissions?.includes('sms_send') ||
      //   user?.roles === 'admin'
      // ) {
      //   getUnreadSmsCount();
      // }
      // socket.off("connect", onConnect);
      // socket.off("disconnect", onDisconnect);
      // socket.off("newSms", handleNewSms);
      // socket.off("mockups-app", getUnreadMockupCount);
    };
  }, [socket]);

  /*   Table functions
   ********************************************* */
  const btn1 = () => <div></div>;

  const table_head = ["URL", "Actions"];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td>{JSON.stringify(item)?.slice(0, 50)}</td>
      <td>
        <button
          onClick={() => {
            setSelectedWebhook(item);
            setShowAddModal(true);
          }}
          type="button"
          className="btn btn-primary btn-sm"
        >
          View
        </button>
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ marginLeft: 260, height: "100vh" }}>
      <h2 className="m-0 ps-1 mt-2 mb-3">
        WebHooks ( {isConnected ? "Connected" : "Disconnected"} ){" "}
      </h2>

      {/*   Table
       ********************************************* */}
      <div
        className="px-1 flex-grow-1 overflow-y-auto d-flex"
        style={{ height: "78vh", borderRadius: 15 }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            btn1={btn1}
            table_head={table_head}
            table_body={table_body}
            table_data={webHookData}
          />
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          {/* Show selected raw webhook in scrollable card as plain text using JSON.stringify */}
          <pre>{JSON.stringify(selectedWebhook, null, 2)}</pre>
        </Modal.Body>
      </Modal>
    </div>
  );
}
